import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseRegimeCostForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Nazov'} value={data.Nazov} onChange={update}/>
            <StringInput name={'Cena'} label={'Cena'} value={data.Cena} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Režijný náklad"
                     labelNew="Pridať Režijný náklad"
                     baseUrl='/service_case/service_cases_regime_costs/'
                     formContent={formContent}
        />
    )
}

export default ServiceCaseRegimeCostForm
